import { combineEpics } from 'redux-observable';

/* BACK & LAY EPICS */
import blBetsEpics from './bets';
import blMyBetsEpics from './myBets';
import blPayoutsEpics from './payouts';

export default combineEpics(
  blPayoutsEpics,
  blBetsEpics,
  blMyBetsEpics,
);
